
define('tpl!taoQtiItem/qtiCreator/tpl/toolbars/okButton', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<button class=\"btn-info small widget-ok\" data-edit=\"active\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "done", options) : helperMissing.call(depth0, "__", "done", options)))
    + "</button>";
  return buffer;
  });
});

